import * as mutations from './consts';
import themes from '@/config/themes';
import timeout from '@/helpers/timeout';
import PublicApiService from '@/resource/publicApi/provider';

export default {
  setUITheme({ commit }, payload) {
    if (themes[payload]) {
      commit(mutations.SET_UI_THEME, payload);
      console.warn(`Theme finded: ${payload}, will be setted `);
    } else {
      commit(mutations.SET_UI_THEME, 'basic');
      console.warn(`No preinstalled theme with passed name ${payload}, will be setted default one`);
    }
  },

  // API key initialization action
  processApiKey({ commit }, payload) {
    commit(mutations.SET_PUBLIC_API_KEY, payload);
  },

  // Set services that comes from API call
  setServices({ commit }, payload) {
    console.log('Paylaod Serivces', payload);

    commit(mutations.SET_SERVICES, payload);
  },

  // Set methods that comes from API call
  setMethods({ commit }, payload) {
    commit(mutations.SET_METHODS, payload);
  },

  /**
   *
   * TODO: Set method_disabled flag on a passed payment method in methods array (by reference)
   * @param {Object} commit context
   * @param {Object} method method object, only ID needed but anyway.
   */
  disableMethod({ commit }, method) {
    commit(mutations.SET_DISABLED_METHOD, method.code);
  },

  setDisabledService({ commit }, service) {
    commit(mutations.SET_DISABLED_SERVICE, service.code);
  },

  // Method to process payment
  selectMethod({ commit }, payload) {
    commit(mutations.SET_NAVIGATION_DATA, [
      {
        name: 'home',
        callback: 'return',
      },
      {
        name: payload.name[(this.$i18n || {}).locale || 'en'],
        callback: 'breadcrumb',
      },
    ]);
    commit(mutations.SET_SELECTED_METHOD, payload);
  },

  // Service to process payment
  selectService({ commit }, payload) {
    commit(mutations.SET_SELECTED_SERVICE, payload);
  },

  // Set of enabled categories
  setCategories({ commit }, payload) {
    commit(mutations.SET_CATEGORIES_LIST, payload);
  },

  // SelectedCategory
  selectCategory({ commit }, payload) {
    commit(mutations.SET_SELECTED_CATEGORY, payload);
  },

  setGroupedServices({ commit }, payload) {
    commit(mutations.SET_GROUPED_SERVICES, payload);
  },

  setGroupedCategories({ commit }, payload) {
    commit(mutations.SET_GROUPED_CATEGORIES, payload);
  },

  // Initialize application state
  setInitState({ commit }, payload) {
    return new Promise((res, rej) => {
      commit(mutations.SET_INIT_STATE, payload);
      res(payload);
    });
  },

  // Initialize commerce account data, which we get from prerequest

  setCommerceAccountData({ commit }, payload) {
    commit(mutations.SET_COMMERCE_ACCOUNT_DATA, payload);
  },

  async createPaymentInvoice({ commit, state }, payload) {
    const { customer = null } = state.invoiceInitialData || {};

    const paymentInvoiceResponse = await PublicApiService.createPaymentInvoice({
      ...payload,
      ...(customer ? { customer } : {}),
    });
    // All hope on API -> data.data ;
    // FIXME: maybe fix nesting.
    const { active_payment = {}, service_flow = '' } = paymentInvoiceResponse.data.data;

    // HARDCODE HARDCODE HARDCODE
    if (service_flow === 'test') {
      commit(mutations.SET_FLOW_DATA, active_payment);
      return Promise.resolve(paymentInvoiceResponse);
    }
    commit(mutations.SET_PAYMENT_INVOICE_DATA, paymentInvoiceResponse.data);
    commit(mutations.SET_FLOW_DATA, active_payment);
  },

  async confirmPaymentInvoice({ commit }, data) {
    return await PublicApiService.confirmPaymentInvoice(data);
  },

  async getPaymentInvoiceById({ commit }, id) {
    const resp = await PublicApiService.getPaymentInvoiceById(id);

    commit(mutations.SET_PAYMENT_INVOICE_DATA, resp);

    resp &&
      resp.data &&
      resp.data.data &&
      resp.data.data.active_payment &&
      commit(mutations.SET_FLOW_DATA, resp.data.data.active_payment);
  },

  async getCheckoutOptions({ commit }, params) {
    try {
      const resp = await timeout(5000, PublicApiService.getCheckoutOptions(params));

      if (resp && resp.data && resp.data.data) {
        commit(mutations.SET_CHECKOUT_OPTIONS, resp.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch checkout options:', error);
    }
  },

  setAutoProcessData({ commit }, payload) {
    commit(mutations.SET_AUTO_PROCESS_DATA, payload);
  },

  /**
   *
   * @param {Object} commit Vuex destructured context
   * @param {String} payload Search string from UI, to get filtered methods
   */
  handleSearch({ commit }, payload) {
    commit(mutations.SET_SEARCH_DATA, payload);
  },

  setTabsNavigationData({ commit }, payload) {
    commit(mutations.SET_NAVIGATION_DATA, payload);
  },

  // Global or fatal error, that triggers error stub on entire page
  setGlobalError({ commit }, payload) {
    commit(mutations.SET_GLOBAL_ERROR, payload);
  },
};
